module.exports = __webpack_public_path__ + "img/pavithram-logo-header-1.eef7c393.png";